import { forwardRef, useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import get from 'transmute/get';
import ViewerTopLevelLogicGroupItem from './ViewerTopLevelLogicGroupItem';
import BannersContainer from 'customer-data-filters-ui/components/common/BannersContainer';
import ViewerAddGroup from './ViewerAddGroup';
import ScrollingBodyContainer from '../common/ScrollingBodyContainer';
import ScrollToFilterButton from '../common/ScrollToFilterButton';
import { isLogicGroupHasAtLeastOneCondition } from '../../filterQueryFormat/logic/LogicGroup';
import TopLevelLogicGroupToggle from './TopLevelLogicGroupToggle';
import { hasFlexibleLogicGroupConditions } from '../../permissions/gates';
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isHorizontal = direction => direction === 'horizontal' || direction === 'both';
const isVertical = direction => direction === 'vertical' || direction === 'both';
const DefaultScrollContainer = styled.div.withConfig({
  displayName: "ViewerContentStandard__DefaultScrollContainer",
  componentId: "kphil-0"
})(["height:100%;width:100%;overflow-x:", ";overflow-y:", ";position:relative;"], props => isHorizontal(props.scrollDirection) ? 'auto' : 'hidden', props => isVertical(props.scrollDirection) ? 'auto' : 'hidden');
const ScrollContainer = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    onScroll,
    scrollDirection
  } = props;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ScrollToFilterButton, {}), /*#__PURE__*/_jsx(DefaultScrollContainer, {
      onScroll: onScroll,
      scrollDirection: scrollDirection,
      ref: ref,
      children: children
    })]
  });
});

// eslint-disable-next-line react/no-multi-comp
const ViewerContentStandard = ({
  inputUse
}) => {
  const {
    internalDraftValue,
    isInEditMode,
    props: {
      strategy,
      isAndGroup,
      matchStatuses,
      bannerComponents,
      uiMessages: {
        viewerEmptyFiltersForSkipEmptyFiltersState
      },
      canEditLogicGroupConditions = false
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const logicOperator = internalDraftValue === null || internalDraftValue === void 0 ? void 0 : internalDraftValue.logicGroupName;

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const noFiltersSet = internalDraftValue.conditions.size === 0;
  const isSingleEmptyFilterGroup =
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  internalDraftValue.conditions.size === 1 &&
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  !isLogicGroupHasAtLeastOneCondition(internalDraftValue.conditions.get('0'));
  const customEditEmptyState = viewerEmptyFiltersForSkipEmptyFiltersState ? /*#__PURE__*/_jsx(View, {
    textAlign: "center",
    marginBlockStart: "1100",
    children: viewerEmptyFiltersForSkipEmptyFiltersState
  }) : null;
  const renderCustomEditEmptyState = isSingleEmptyFilterGroup && customEditEmptyState;
  const renderGroups = !noFiltersSet && !renderCustomEditEmptyState;
  const renderAddGroup = !renderCustomEditEmptyState;
  const showTopLevelLogicGroupToggle =
  // has the consuming app opted-in
  canEditLogicGroupConditions &&
  // does the strategy support it (only ILS has supported)
  strategy.canEditLogicGroupCondition && hasFlexibleLogicGroupConditions() && isInEditMode;
  return /*#__PURE__*/_jsx(ScrollingBodyContainer, {
    id: "cdf-viewer-scrolling-container",
    ScrollContainer: ScrollContainer,
    children: /*#__PURE__*/_jsxs(FoundationsView, {
      "data-selenium-test": "fr-viewer-panel",
      paddingBlockStart: "0",
      paddingInline: "400",
      paddingBlockEnd: "400",
      as: "div",
      children: [/*#__PURE__*/_jsx(BannersContainer, {
        children: bannerComponents
      }), showTopLevelLogicGroupToggle && /*#__PURE__*/_jsx(TopLevelLogicGroupToggle, {}), renderCustomEditEmptyState ? customEditEmptyState : null, renderGroups ?
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      internalDraftValue.conditions.toArray().map((group, index) => {
        if (isAndGroup && index !== 0) {
          return null;
        }
        return /*#__PURE__*/_jsx(ViewerTopLevelLogicGroupItem, {
          inputUse: inputUse,
          logicGroup: group,
          logicGroupIndex: index
          // @ts-expect-error logicOperator might be undefined
          ,
          logicOperator: logicOperator
          // @ts-expect-error ts-migrate(2345) FIXME
          ,
          matchStatus: get(index, matchStatuses)
        }, `${index}-${group.name}`);
      }) : null, renderAddGroup && /*#__PURE__*/_jsx(ViewerAddGroup, {})]
    })
  });
};
export default ViewerContentStandard;